/** * * Asynchronously loads the component for
Practice Info
* */ import { lazyLoad } from "utils/loadable";
export const PracticeInfo = lazyLoad(
  () => import("./index"),
  (module) => module.PracticeInfo
);